import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IAppState, IUserRoleSetupState } from '../shared/models/store.model'
import { EXPIRATION_TYPE, GROUP_TYPE_OPTIONS } from '../shared/models/userRole.model'

const initialState: IUserRoleSetupState = {
  editUserRoleSetUp: {
    primaryGroupType: GROUP_TYPE_OPTIONS.BANK_ACCESS,
    roleName: '',
    selectAll: false,
    navigationOptions: [],
    permissions: [],
    emails: [],
    expirations: EXPIRATION_TYPE.DOES_NOT_EXPIRE,
    expirationMinutes: null,
    expirationDays: null,
  },
  userRoleDataSetUp: {
    primaryGroupTypes: [],
    modules: [],
    permissions: [],
    emails: [],
  },
}

const userRoleSetupReducer = createSlice({
  name: 'userRoleSetup',
  initialState,
  reducers: {
    setUpPrimaryGroupTypes(state: any, action: PayloadAction<any>) {
      state.userRoleDataSetUp.primaryGroupTypes = action.payload
    },
    setUpModules(state: any, action: PayloadAction<any>) {
      state.userRoleDataSetUp.modules = action.payload
    },
    setUpPermissions(state: any, action: PayloadAction<any>) {
      state.userRoleDataSetUp.permissions = action.payload
    },
    setUpEmails(state: any, action: PayloadAction<any>) {
      state.userRoleDataSetUp.emails = action.payload
    },
    setPrevDataEditUserSetup(state: any, action: PayloadAction<any>) {
      state.editUserRoleSetUp = action.payload
    },
  },
})

const rootState = (state: IAppState) => state.userRoleSetup

export const getEditUserRoleConfig = createSelector(rootState, (state: any) => state.editUserRoleSetUp)

export const getPrimaryGroupSetup = createSelector(
  rootState,
  (state: any) => state?.userRoleDataSetUp.primaryGroupTypes,
)
export const getModulesSetup = createSelector(rootState, (state: any) => state?.userRoleDataSetUp.modules)
export const getPermissionsSetup = createSelector(rootState, (state: any) => state?.userRoleDataSetUp.permissions)
export const getEmailsSetup = createSelector(rootState, (state: any) => state?.userRoleDataSetUp.emails)

export const { setUpPrimaryGroupTypes, setUpModules, setUpPermissions, setUpEmails, setPrevDataEditUserSetup } =
  userRoleSetupReducer.actions

export default userRoleSetupReducer
